// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.top-toolbar {
  position: relative;
  height: 56px;
  z-index: 1;
  color: #fff;
}
.top-toolbar:not(.auth-main-toolbar) {
  background: transparent !important;
  background-image: linear-gradient(#283593, #0099f7) !important;
  background-repeat: no-repeat;
  background-size: cover;
}
.top-toolbar .menu-icon-rotated {
  transform: rotate(90deg);
}

.auth-main-toolbar {
  border-radius: 10px 10px 0 0;
  background: transparent !important;
  background-image: linear-gradient(#283593, #0099f7) !important;
  background-repeat: no-repeat;
  background-size: cover;
}

.auth-main-toolbar::before {
  display: none;
}

.pin {
  width: 24px;
  height: 24px;
  cursor: pointer;
  fill: currentColor;
}

.sidenav {
  width: 260px;
  overflow: hidden;
  border: none !important;
}

.header {
  position: relative;
  z-index: 2;
  transition: 0.3s;
}
.header.over {
  z-index: 99;
}

.search-bar form input {
  height: 28px;
  border: none;
  padding: 0;
  border-radius: 15px;
  outline: none;
  color: #444;
  width: 0;
  overflow: hidden;
  transition: 0.3s;
}
.search-bar form input.show {
  padding: 0 8px;
  width: 250px;
}

.footer {
  height: 0px;
  position: relative;
  z-index: 3;
}

.options {
  position: fixed;
  width: 260px;
  z-index: 999999;
}
.options .op-header {
  height: 56px;
  padding: 0 14px;
}
.options .control {
  padding: 6px 14px;
}
.options .control div {
  padding: 6px 0;
}
.options .control h4 {
  border-bottom: 1px solid #ccc;
  margin: 12px 0 6px 0;
}
.options .control .skin-primary {
  width: 46px;
  height: 46px;
  padding: 0;
  overflow: hidden;
  cursor: pointer;
}
.options .control .skin-primary .skin-secondary {
  width: 0;
  height: 0;
  padding: 0;
  border-bottom: 46px solid;
  border-left: 46px solid transparent;
}
.options .control .skin-primary.indigo-light {
  background-color: #3F51B5;
  border: 1px solid #3F51B5;
}
.options .control .skin-primary.indigo-light .skin-secondary {
  border-bottom-color: #ececec;
}
.options .control .skin-primary.teal-light {
  background-color: #009688;
  border: 1px solid #009688;
}
.options .control .skin-primary.teal-light .skin-secondary {
  border-bottom-color: #ececec;
}
.options .control .skin-primary.red-light {
  background-color: #F44336;
  border: 1px solid #F44336;
}
.options .control .skin-primary.red-light .skin-secondary {
  border-bottom-color: #ececec;
}
.options .control .skin-primary.gray-light {
  background-color: #757575;
  border: 1px solid #757575;
}
.options .control .skin-primary.gray-light .skin-secondary {
  border-bottom-color: #ececec;
}
.options .control .skin-primary.blue-dark {
  background-color: #0277bd;
  border: 1px solid #0277bd;
}
.options .control .skin-primary.blue-dark .skin-secondary {
  border-bottom-color: #262626;
}
.options .control .skin-primary.green-dark {
  background-color: #388E3C;
  border: 1px solid #388E3C;
}
.options .control .skin-primary.green-dark .skin-secondary {
  border-bottom-color: #262626;
}
.options .control .skin-primary.pink-dark {
  background-color: #D81B60;
  border: 1px solid #D81B60;
}
.options .control .skin-primary.pink-dark .skin-secondary {
  border-bottom-color: #262626;
}
.options .control .skin-primary.gray-dark {
  background-color: #607D8B;
  border: 1px solid #607D8B;
}
.options .control .skin-primary.gray-dark .skin-secondary {
  border-bottom-color: #262626;
}
.options .mat-radio-group,
.options .mat-mdc-radio-group {
  display: inline-flex;
  flex-direction: column;
}
.options .mat-radio-group .mat-radio-button,
.options .mat-radio-group .mat-mdc-radio-button,
.options .mat-mdc-radio-group .mat-radio-button,
.options .mat-mdc-radio-group .mat-mdc-radio-button {
  margin: 2px 0;
}
.options .mat-slide-toggle,
.options .mat-mdc-slide-toggle {
  height: auto;
}
.options .ps {
  height: calc(100% - 56px);
}

.op-image {
  box-shadow: 0 0 2px #ccc;
  border: 2px solid;
  border-color: transparent;
  cursor: pointer;
  transition: 0.2s;
}

.options-icon {
  position: fixed;
  top: 120px;
  right: 0;
  width: 40px;
  height: 40px;
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  cursor: pointer;
  z-index: 99999;
}
.options-icon .mat-icon {
  animation: spin 8s linear infinite;
}
@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}
.back-to-top {
  position: fixed;
  width: 40px;
  height: 40px;
  cursor: pointer;
  z-index: 999999;
  right: 20px;
  bottom: 65px;
  opacity: 0.5;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.75);
  border-radius: 50%;
  transition: 0.3s;
}
.back-to-top:hover {
  opacity: 0.9;
}`, "",{"version":3,"sources":["webpack://./src/app/shared-component/auth-layout/auth-layout.component.scss","webpack://./src/app/theme/styles/_variables.scss"],"names":[],"mappings":"AAKA;EACI,kBAAA;EACA,YCFiB;EDGjB,UAAA;EACA,WAAA;AAJJ;AAMI;EAEI,kCAAA;EACA,8DAAA;EACA,4BAAA;EACA,sBAAA;AALR;AAQI;EACI,wBAAA;AANR;;AAWA;EACI,4BAAA;EACA,kCAAA;EACA,8DAAA;EACA,4BAAA;EACA,sBAAA;AARJ;;AAWA;EAEI,aAAA;AATJ;;AAYA;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;AATJ;;AAYA;EACI,YCpCY;EDqCZ,gBAAA;EACA,uBAAA;AATJ;;AAYA;EACI,kBAAA;EACA,UAAA;EACA,gBAAA;AATJ;AAWI;EACI,WAAA;AATR;;AAeQ;EACI,YAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;EACA,QAAA;EACA,gBAAA;EACA,gBAAA;AAZZ;AAcY;EACI,cAAA;EACA,YAAA;AAZhB;;AAkBA;EACI,WC5EoB;ED6EpB,kBAAA;EACA,UAAA;AAfJ;;AAmBA;EACI,eAAA;EACA,YCjFY;EDkFZ,eAAA;AAhBJ;AAkBI;EACI,YC1Fa;ED2Fb,eAAA;AAhBR;AAmBI;EACI,iBAAA;AAjBR;AAmBQ;EACI,cAAA;AAjBZ;AAoBQ;EACI,6BAAA;EACA,oBAAA;AAlBZ;AAqBQ;EACI,WAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;AAnBZ;AAqBY;EACI,QAAA;EACA,SAAA;EACA,UAAA;EACA,yBAAA;EACA,mCAAA;AAnBhB;AAsBY;EACI,yBAAA;EACA,yBAAA;AApBhB;AAsBgB;EACI,4BAAA;AApBpB;AAwBY;EACI,yBAAA;EACA,yBAAA;AAtBhB;AAwBgB;EACI,4BAAA;AAtBpB;AA0BY;EACI,yBAAA;EACA,yBAAA;AAxBhB;AA0BgB;EACI,4BAAA;AAxBpB;AA4BY;EACI,yBAAA;EACA,yBAAA;AA1BhB;AA4BgB;EACI,4BAAA;AA1BpB;AA8BY;EACI,yBAAA;EACA,yBAAA;AA5BhB;AA8BgB;EACI,4BAAA;AA5BpB;AAgCY;EACI,yBAAA;EACA,yBAAA;AA9BhB;AAgCgB;EACI,4BAAA;AA9BpB;AAkCY;EACI,yBAAA;EACA,yBAAA;AAhChB;AAkCgB;EACI,4BAAA;AAhCpB;AAoCY;EACI,yBAAA;EACA,yBAAA;AAlChB;AAoCgB;EACI,4BAAA;AAlCpB;AAwCI;;EAEI,oBAAA;EACA,sBAAA;AAtCR;AAwCQ;;;;EAEI,aAAA;AApCZ;AAwCI;;EAEI,YAAA;AAtCR;AAyCI;EACI,yBAAA;AAvCR;;AA2CA;EACI,wBAAA;EACA,iBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;AAxCJ;;AA2CA;EACI,eAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;AAxCJ;AA0CI;EAGI,kCAAA;AAxCR;AAwDA;EACI;IACI,yBAAA;EA3CN;AACF;AA8CA;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,qCAAA;EACA,kBAAA;EACA,gBAAA;AA5CJ;AA8CI;EACI,YAAA;AA5CR","sourcesContent":["// ==========================================================================\n// Component: Auth-layout.component\n// ==========================================================================\n@use \"../../theme/styles/variables\" as *;\n\n.top-toolbar {\n    position: relative;\n    height: $top-toolbar-height;\n    z-index: 1;\n    color: #fff;\n\n    &:not(.auth-main-toolbar) {\n        // Keep legacy look for secondary toolbars (e.g. fixed sidenav toolbar)\n        background: transparent !important;\n        background-image: linear-gradient(#283593, #0099f7) !important;\n        background-repeat: no-repeat;\n        background-size: cover;\n    }\n\n    .menu-icon-rotated {\n        transform: rotate(90deg);\n    }\n\n}\n\n.auth-main-toolbar {\n    border-radius: 10px 10px 0 0;\n    background: transparent !important;\n    background-image: linear-gradient(#283593, #0099f7) !important;\n    background-repeat: no-repeat;\n    background-size: cover;\n}\n\n.auth-main-toolbar::before {\n    // Remove ctx grid overlay for this toolbar\n    display: none;\n}\n\n.pin {\n    width: 24px;\n    height: 24px;\n    cursor: pointer;\n    fill: currentColor;\n}\n\n.sidenav {\n    width: $sidenav-width;\n    overflow: hidden;\n    border: none !important;\n}\n\n.header {\n    position: relative;\n    z-index: 2;\n    transition: 0.3s;\n\n    &.over {\n        z-index: 99;\n    }\n}\n\n.search-bar {\n    form {\n        input {\n            height: 28px;\n            border: none;\n            padding: 0;\n            border-radius: 15px;\n            outline: none;\n            color: #444;\n            width: 0;\n            overflow: hidden;\n            transition: 0.3s;\n\n            &.show {\n                padding: 0 8px;\n                width: 250px;\n            }\n        }\n    }\n}\n\n.footer {\n    height: $footer-toolbar-height;\n    position: relative;\n    z-index: 3;\n}\n\n\n.options {\n    position: fixed;\n    width: $sidenav-width;\n    z-index: 999999;\n\n    .op-header {\n        height: $top-toolbar-height;\n        padding: 0 14px;\n    }\n\n    .control {\n        padding: 6px 14px;\n\n        div {\n            padding: 6px 0;\n        }\n\n        h4 {\n            border-bottom: 1px solid #ccc;\n            margin: 12px 0 6px 0;\n        }\n\n        .skin-primary {\n            width: 46px;\n            height: 46px;\n            padding: 0;\n            overflow: hidden;\n            cursor: pointer;\n\n            .skin-secondary {\n                width: 0;\n                height: 0;\n                padding: 0;\n                border-bottom: 46px solid;\n                border-left: 46px solid transparent;\n            }\n\n            &.indigo-light {\n                background-color: #3F51B5;\n                border: 1px solid #3F51B5;\n\n                .skin-secondary {\n                    border-bottom-color: #ececec;\n                }\n            }\n\n            &.teal-light {\n                background-color: #009688;\n                border: 1px solid #009688;\n\n                .skin-secondary {\n                    border-bottom-color: #ececec;\n                }\n            }\n\n            &.red-light {\n                background-color: #F44336;\n                border: 1px solid #F44336;\n\n                .skin-secondary {\n                    border-bottom-color: #ececec;\n                }\n            }\n\n            &.gray-light {\n                background-color: #757575;\n                border: 1px solid #757575;\n\n                .skin-secondary {\n                    border-bottom-color: #ececec;\n                }\n            }\n\n            &.blue-dark {\n                background-color: #0277bd;\n                border: 1px solid #0277bd;\n\n                .skin-secondary {\n                    border-bottom-color: #262626;\n                }\n            }\n\n            &.green-dark {\n                background-color: #388E3C;\n                border: 1px solid #388E3C;\n\n                .skin-secondary {\n                    border-bottom-color: #262626;\n                }\n            }\n\n            &.pink-dark {\n                background-color: #D81B60;\n                border: 1px solid #D81B60;\n\n                .skin-secondary {\n                    border-bottom-color: #262626;\n                }\n            }\n\n            &.gray-dark {\n                background-color: #607D8B;\n                border: 1px solid #607D8B;\n\n                .skin-secondary {\n                    border-bottom-color: #262626;\n                }\n            }\n        }\n    }\n\n    .mat-radio-group,\n    .mat-mdc-radio-group {\n        display: inline-flex;\n        flex-direction: column;\n\n        .mat-radio-button,\n        .mat-mdc-radio-button {\n            margin: 2px 0;\n        }\n    }\n\n    .mat-slide-toggle,\n    .mat-mdc-slide-toggle {\n        height: auto;\n    }\n\n    .ps {\n        height: calc(100% - #{$top-toolbar-height});\n    }\n}\n\n.op-image {\n    box-shadow: 0 0 2px #ccc;\n    border: 2px solid;\n    border-color: transparent;\n    cursor: pointer;\n    transition: 0.2s;\n}\n\n.options-icon {\n    position: fixed;\n    top: 120px;\n    right: 0;\n    width: 40px;\n    height: 40px;\n    background: rgba(0, 0, 0, .7);\n    color: #fff;\n    cursor: pointer;\n    z-index: 99999;\n\n    .mat-icon {\n        -webkit-animation: spin 8s linear infinite;\n        -moz-animation: spin 8s linear infinite;\n        animation: spin 8s linear infinite;\n    }\n}\n\n@-moz-keyframes spin {\n    100% {\n        -moz-transform: rotate(360deg);\n    }\n}\n\n@-webkit-keyframes spin {\n    100% {\n        -webkit-transform: rotate(360deg);\n    }\n}\n\n@keyframes spin {\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n.back-to-top {\n    position: fixed;\n    width: 40px;\n    height: 40px;\n    cursor: pointer;\n    z-index: 999999;\n    right: 20px;\n    bottom: 65px;\n    opacity: .5;\n    color: #fff;\n    background-color: rgba(0, 0, 0, .75);\n    border-radius: 50%;\n    transition: 0.3s;\n\n    &:hover {\n        opacity: 0.9;\n    }\n}\n","// ==========================================================================\r\n// Component: Variables\r\n// ==========================================================================\r\n$main-font-family: 'Roboto', sans-serif;\r\n\r\n$top-toolbar-height: 56px; \r\n$horizontal-menu-height: 64px; \r\n$footer-toolbar-height: 0px; \r\n//$footer-toolbar-height: 56px; \r\n\r\n$sidenav-width: 260px;\r\n$compact-sidenav-width: 170px;\r\n$mini-sidenav-width: 66px;"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
